/*Get TRAINING SUBJECTS */
export const GET_TRAININGSUBJECTS = "GET_TRAININGSUBJECTS"
export const GET_TRAININGSUBJECTS_SUCCESS = "GET_TRAININGSUBJECTS_SUCCESS"
export const GET_TRAININGSUBJECTS_FAIL = "GET_TRAININGSUBJECTS_FAIL"

/*Get TRAINING TYPES */
export const GET_TRAININGTYPES = "GET_TRAININGTYPES"
export const GET_TRAININGTYPES_SUCCESS = "GET_TRAININGTYPES_SUCCESS"
export const GET_TRAININGTYPES_FAIL = "GET_TRAININGTYPES_FAIL"

/*Get TRAINING MONTHS */
export const GET_TRAININGMONTHS = "GET_TRAININGMONTHS"
export const GET_TRAININGMONTHS_SUCCESS = "GET_TRAININGMONTHS_SUCCESS"
export const GET_TRAININGMONTHS_FAIL = "GET_TRAININGMONTHS_FAIL"

/*Get HOUSEHOLDS */
export const GET_HOUSEHOLDS = "GET_HOUSEHOLDS"
export const GET_HOUSEHOLDS_SUCCESS = "GET_HOUSEHOLDS_SUCCESS"
export const GET_HOUSEHOLDS_FAIL = "GET_HOUSEHOLDS_FAIL"

/**
 * Add HOUSEHOLD
 */
export const ADD_HOUSEHOLD = "ADD_HOUSEHOLD"
export const ADD_HOUSEHOLD_SUCCESS = "ADD_HOUSEHOLD_SUCCESS"
export const ADD_HOUSEHOLD_FAIL = "ADD_HOUSEHOLD_FAIL"

/**
 * Update HOUSEHOLD
 *
 */
export const UPDATE_HOUSEHOLD = "UPDATE_HOUSEHOLD"
export const UPDATE_HOUSEHOLD_SUCCESS = "UPDATE_HOUSEHOLD_SUCCESS"
export const UPDATE_HOUSEHOLD_FAIL = "UPDATE_HOUSEHOLD_FAIL"

/*Get HOUSEHOLD DETAIL */
export const GET_HOUSEHOLD_DETAIL = "GET_HOUSEHOLD_DETAIL"
export const GET_HOUSEHOLD_DETAIL_SUCCESS = "GET_HOUSEHOLD_DETAIL_SUCCESS"
export const GET_HOUSEHOLD_DETAIL_FAIL = "GET_HOUSEHOLD_DETAIL_FAIL"

/*Add FILE UPLOAD */
export const ADD_HOUSEHOLD_FILEUPLOAD = "ADD_HOUSEHOLD_FILEUPLOAD"
export const ADD_HOUSEHOLD_FILEUPLOAD_SUCCESS =
  "ADD_HOUSEHOLD_FILEUPLOAD_SUCCESS"
export const ADD_HOUSEHOLD_FILEUPLOAD_FAIL = "ADD_HOUSEHOLD_FILEUPLOAD_FAIL"

// actionTypes.js
export const ADD_HOUSEHOLD_DATAUPLOAD = "ADD_HOUSEHOLD_DATAUPLOAD"
export const ADD_HOUSEHOLD_DATAUPLOAD_SUCCESS =
  "ADD_HOUSEHOLD_DATAUPLOAD_SUCCESS"
export const ADD_HOUSEHOLD_DATAUPLOAD_FAIL = "ADD_HOUSEHOLD_DATAUPLOAD_FAIL"

/**
 * Add SUBJECT
 */
export const ADD_SUBJECT = "ADD_SUBJECT"
export const ADD_SUBJECT_SUCCESS = "ADD_SUBJECT_SUCCESS"
export const ADD_SUBJECT_FAIL = "ADD_SUBJECT_FAIL"

/**
 * Update SUBJECT
 *
 */
export const UPDATE_SUBJECT = "UPDATE_SUBJECT"
export const UPDATE_SUBJECT_SUCCESS = "UPDATE_SUBJECT_SUCCESS"
export const UPDATE_SUBJECT_FAIL = "UPDATE_SUBJECT_FAIL"

/*Get SUBJECT DETAIL */
export const GET_SUBJECT_DETAIL = "GET_SUBJECT_DETAIL"
export const GET_SUBJECT_DETAIL_SUCCESS = "GET_SUBJECT_DETAIL_SUCCESS"
export const GET_SUBJECT_DETAIL_FAIL = "GET_SUBJECT_DETAIL_FAIL"

/*Clear State*/
export const CLEAR_HOUSEHOLD_STATE = "CLEAR_HOUSEHOLD_STATE"
